'use strict'

// p-timeout is copied here because we don't transpile node_modules
// https://github.com/sindresorhus/p-timeout/blob/e6bed583f6f0062177e6230fe1b06474b811be27/index.js

export class TimeoutError extends Error {
  constructor (message) {
    super(message)
    this.name = this.constructor.name
  }
}

export default (promise, ms, fallback) => new Promise((resolve, reject) => {
  if (!Number.isFinite(ms)) {
    throw new TypeError('Expected `ms` to be a finite number')
  }

  const timer = setTimeout(() => {
    if (typeof fallback === 'function') {
      resolve(fallback())
      return
    }

    const message = typeof fallback === 'string' ? fallback : `Promise timed out after ${ms} milliseconds`
    const err = fallback instanceof Error ? fallback : new TimeoutError(message)

    reject(err)
  }, ms)

  promise.then(
    val => {
      clearTimeout(timer)
      resolve(val)
    },
    err => {
      clearTimeout(timer)
      reject(err)
    }
  )
})



// WEBPACK FOOTER //
// ./lib/p-timeout.js